<template>

</template>

<script>
    export default {
        name: "Subscriptions.vue"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Subscriptions.vue